<template>
  <div>
    <div class="guide mb-3 body-2">
      <p>
        ワンウェイ(乗り捨て)サービスをご利用いただけます。<br>
        返却場所の一覧は<a href="https://netzfukuoka.jp/tenpo_all" target="_blank">こちら</a>をご覧ください。
      </p>
    </div>
    <v-select
      :items="items"
      v-model="opts.locationid"
      item-text="name"
      item-value="id"
      menu-props="auto"
      label="ワンウェイサービス"
      prepend-icon="map"
      single-line
    >
      <template v-slot:item="{item}">
        <div class="d-flex align-baseline w-full">
          <span class="flex-grow-1">{{item.name}}</span>
          <!--
          <template v-if="item.price !== 0">
            <span>{{item.price | comma}}</span>
            <small class="ml-1">円</small>
          </template>
          -->
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import PartBase from '@/mixins/PartBase'

export default {
  name: 'OptLocations',
  mixins: [
    PartBase
  ],
  props: {
    opts: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
